import styled from 'styled-components';

const Loader = () => {
  return (
    <Wrapper>
      <LoadingELement />
    </Wrapper>
  );
};

export default Loader;

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  background-color: rgba(93, 165, 237, 0.1);
  backdrop-filter: blur(10px);
  z-index: 9999;
`;

const LoadingELement = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;

  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #5da6ed;
    border-color: #5da6ed transparent #5da6ed transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
